import type { Location, Params } from 'react-router-dom'

import { ApolloClient } from '@apollo/client'
import { ShiftManagementPageDocument } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'
import { Navigation, NavigationPaths } from 'modules/core/lib/navigation/context'

export const settingsOptions = (
  params: Params,
  location: Location,
  navigation: Navigation<NavigationPaths>,
  watchQuery: ApolloClient<unknown>['watchQuery']
) => {
  return watchQuery({
    query: ShiftManagementPageDocument,
    variables: {},
  }).map(({ data }) => {
    const { viewType, groupType, year, month, day } = params
    const savedShiftsPath = navigation.shifts.savedShifts.fullPath()
    const rotatingShiftPath = navigation.shifts.templates.fullPath()
    if ([savedShiftsPath, rotatingShiftPath].includes(location.pathname)) {
      return {
        unsafeDisableNewLayout: true,
        title: i18n.t('shift_management.section.title'),
      }
    }
    const canSeeBalanceExport = Boolean(data?.timeBalance?._policies.accessSeeTimeBalanceExport.can)
    const canSeeInsights = Boolean(data?.shiftManagement?._policies.accessSeeTimeInsights.can)

    return {
      unsafeDisableNewLayout: true,
      title: i18n.t('shift_management.section.title'),
      settings: {
        items: [
          {
            label: i18n.t('shift_management.settings.title'),
            href: navigation.shifts.savedShifts.fullPath(),
            isVisible: true,
          },
          {
            label: i18n.t('shift_management.settings.break_title'),
            href: navigation.settings.time_categories_settings.fullPath(),
            isVisible: true,
          },
          {
            label: i18n.t('shift_management.actions.export_annual_balance.title'),
            href: navigation.shifts.customViewGroup.exportAnnualBalance.fullPath({
              viewType: String(viewType),
              groupType: String(groupType),
              year: Number(year),
              month: Number(month),
              day: Number(day),
            }),
            isVisible: canSeeBalanceExport,
          },
          {
            label: i18n.t('shift_management.time_insights.title'),
            href: navigation.shifts.customViewGroup.insightsRequest.fullPath({
              viewType: String(viewType),
              groupType: String(groupType),
              year: Number(year),
              month: Number(month),
              day: Number(day),
            }),
            isVisible: canSeeInsights,
          },
          {
            label: i18n.t('shift_management.actions.export_shifts.title'),
            href: navigation.shifts.customViewGroup.exportSchedule.fullPath({
              viewType: String(viewType),
              groupType: String(groupType),
              year: Number(year),
              month: Number(month),
              day: Number(day),
            }),
            isVisible: true,
          },
          {
            label: i18n.t('shift_management.actions.print_shifts.title'),
            href: navigation.shifts.customViewGroup.printSchedule.fullPath({
              viewType: String(viewType),
              groupType: String(groupType),
              year: Number(year),
              month: Number(month),
              day: Number(day),
            }),
            isVisible: true,
          },
        ].filter((el) => el?.isVisible === true),
      },
    }
  })
}
